<div class="container-global">
  <h2 class="primary-color">MON ESPACE</h2>
  <h3>Propositions commerciales</h3>
  <div class="container-fil-ariane">
    <ags-fil-ariane [name]="'Mon espace'" [link]="'/account'"></ags-fil-ariane>
    <p class="space-fil-ariane"> > </p>
    <ags-fil-ariane [name]="'Mes propositions commerciales'" [link]="'/mespropositionscommerciales'"></ags-fil-ariane>
  </div>
  <lib-ags-kendo-grid-list [titlefield]="'Liste des propositions commerciales'" [gridConfig]="gridSettings"
    [downloadFunction]="documentService.getDocumentPresigned" [table]="'devis'" [data]="propositionList">
  </lib-ags-kendo-grid-list>
</div>
